'use client';

import { FC } from 'react';

import { Heading } from '@purpur/library';
import { IllustrativeIcon404ErrorDuocolorAnimated } from '@purpur/library/illustrative-icon/404-error-duocolor-animated';

import { ButtonLink } from '@telialt/common-button-link/src';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ContentSlot } from '@telialt/core-cms-content/src/components/ContentSlot/ContentSlot';

import { PUBLIC_WEB_CONTENT_TEST_ID } from '../../../test-ids';
import { ContentPageContainer } from '../ContentPageContainer';
import {
    ActionsContainer,
    ContentContainer,
    MediaContainer,
    MessageContainer,
    Paragraph,
    StyledContainer,
} from './NotFoundBlogPage.styles';

const BLOG_PAGE_NOT_FOUND_CONTENT_SLOT = 'blog-page-not-found';

export const NotFoundBlogPage: FC = () => {
    const { t } = useTranslations();

    return (
        <ContentPageContainer>
            <StyledContainer>
                <ContentContainer>
                    <MessageContainer>
                        <Heading tag="h1" variant="title-500">
                            {t['blog.page_not_found.title']}
                        </Heading>
                        <Paragraph>{t['blog.page_not_found.message']}</Paragraph>
                    </MessageContainer>
                    <ActionsContainer>
                        <ButtonLink
                            showIcon={true}
                            icon="forward"
                            dataTest={PUBLIC_WEB_CONTENT_TEST_ID.NOT_FOUND_PRIMARY_BUTTON}
                            variant="primary"
                            href={t['blog.page_not_found.primary_button_url']}
                        >
                            {t['blog.page_not_found.primary_button_label']}
                        </ButtonLink>
                        <ButtonLink
                            showIcon={true}
                            icon="forward"
                            dataTest={PUBLIC_WEB_CONTENT_TEST_ID.NOT_FOUND_SECONDARY_BUTTON}
                            variant="secondary"
                            href={t['blog.page_not_found.secondary_button_url']}
                        >
                            {t['blog.page_not_found.secondary_button_label']}
                        </ButtonLink>
                    </ActionsContainer>
                </ContentContainer>
                <MediaContainer>
                    <IllustrativeIcon404ErrorDuocolorAnimated autoplay={false} aria-hidden={true} />
                </MediaContainer>
            </StyledContainer>
            <ContentSlot identifier={BLOG_PAGE_NOT_FOUND_CONTENT_SLOT} />
        </ContentPageContainer>
    );
};
